import { Center, Container, Link } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import Loader from '../../components/Loader';
import Subtitle from '../../components/Subtitle';
import Title from '../../components/Title';
import TitleContainer from '../../components/TitleContainer';
import { MAIN_NUMBER } from '../../constants/contact';
import { useEiRedirectMutation } from '../../gql/generated/graphql';
import SimpleLayout from '../layouts/SimpleLayout';

const VerifyInsurance = () => {
  const [error, setError] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const leadId = searchParams.get('leadId');
  const [eiRedirect] = useEiRedirectMutation({
    context: {
      isErrorHandled: true,
    },
  });

  useEffect(() => {
    const handleRedirect = async () => {
      if (!leadId) {
        setError(true);
        return;
      }

      try {
        const result = await eiRedirect({
          variables: {
            leadId,
          },
        });

        const redirectUrl = result.data?.eiRedirect?.url;
        if (redirectUrl) {
          window.location.href = redirectUrl;
        } else {
          setError(true);
        }
      } catch (e) {
        setError(true);
      }
    };

    handleRedirect();
  }, [leadId]);

  if (error || !leadId) {
    return (
      <SimpleLayout>
        <Container textAlign="center">
          <TitleContainer>
            <Title>Invalid link</Title>
          </TitleContainer>
          <Subtitle>
            This link is no longer valid or has expired. Please contact us if you feel you reached
            this page in error.
          </Subtitle>
          <Link href={`tel:+1-${MAIN_NUMBER}`}>{MAIN_NUMBER}</Link>
        </Container>
      </SimpleLayout>
    );
  }

  return (
    <Container textAlign="center">
      <Center mt={8}>
        <Loader />
      </Center>
    </Container>
  );
};

export default VerifyInsurance;
